import { find, sortBy } from 'lodash';

/* this code is meant solely for use internal to this package in `./trackPageView` */
/* it should be kept in sync with the same code in `bricks` */
/* additional context - https://github.com/opendoor-labs/code/pull/11068#discussion_r349428972 */

const BREAKPOINTS_DICT = {
  LG: 1200,
  MD: 992,
  SM: 768,
  XL: 1600,
  XS: 480,
  XXL: 1920,
};
const BREAKPOINTS_SORTED_LIST = sortBy(
  Object.keys(BREAKPOINTS_DICT),
  (key) => -BREAKPOINTS_DICT[key],
);
type IBreakpoint = keyof typeof BREAKPOINTS_DICT;

export const getCurrentBreakpoint = (): IBreakpoint => {
  return find(
    BREAKPOINTS_SORTED_LIST,
    (breakpoint: IBreakpoint) =>
      window.matchMedia(`(min-width: ${BREAKPOINTS_DICT[breakpoint]}px)`).matches,
  ) as IBreakpoint;
};
